import React, { createContext, useContext, useMemo, useState } from "react";
import { useQuery } from "react-apollo-hooks";
import {
  GET_SELECTED_COMMUNITY,
  GET_SELECTED_DIVISION,
} from "../../cacheql/queries";
import {
  ACTIVITY_FEED_FILTER_ALL,
  getDefaultActivityFeedDateRange,
} from "./activity-feed-list-utils";

const ActivityFeedScopeContext = createContext(null);

export const ActivityFeedScopeProvider = ({
  children,
  customerFilter = null,
}) => {
  const { data: { selectedDivision } = {} } = useQuery(GET_SELECTED_DIVISION);
  const { data: { selectedCommunityIds } = {} } = useQuery(
    GET_SELECTED_COMMUNITY
  );

  const [activityTypeCategory, setActivityTypeCategory] = useState(
    ACTIVITY_FEED_FILTER_ALL
  );
  const [dateRange, setDateRangeState] = useState(
    getDefaultActivityFeedDateRange
  );

  const setDateRange = (next) => {
    setDateRangeState((prev) => {
      if (
        prev.startDate === next.startDate &&
        prev.endDate === next.endDate
      ) {
        return prev;
      }
      return next;
    });
  };

  const initialized = selectedDivision !== undefined;
  const divisionId = selectedDivision?.id ?? null;
  const divisionName = selectedDivision?.name;
  const communityIds = selectedCommunityIds?.ids?.length
    ? selectedCommunityIds.ids
    : null;

  const value = useMemo(
    () => ({
      initialized,
      division: divisionId ? { id: divisionId, name: divisionName } : null,
      communityIds,
      customerFilter,
      activityTypeCategory,
      setActivityTypeCategory,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      setDateRange,
    }),
    [
      initialized,
      divisionId,
      divisionName,
      communityIds,
      customerFilter,
      activityTypeCategory,
      dateRange.startDate,
      dateRange.endDate,
    ]
  );

  return (
    <ActivityFeedScopeContext.Provider value={value}>
      {children}
    </ActivityFeedScopeContext.Provider>
  );
};

export const useActivityFeedScope = () => {
  const ctx = useContext(ActivityFeedScopeContext);
  if (!ctx) {
    throw new Error(
      "useActivityFeedScope must be used within ActivityFeedScopeProvider"
    );
  }
  return ctx;
};
